{
	"approveContract": "Aprovar contrato",
	"description": "Você possui contratos pendentes de acordo.",
	"deselectAllContracts": "Desmarcar todos os contratos",
	"modalApproveConfirmation": {
		"description": "Para finalizar a assinatura e confirmar a aprovação enviaremos um código para o e-mail cadastrado. Ao finalizar a assinatura, você só conseguirá cancelar entrando em contato com o canal de suporte.",
		"header": "Confirmação de aprovação",
		"reminder": "Lembrete: verifique sua caixa de spam, o e-mail com o código pode ter sido direcionado para ela.",
		"sendCode": "Enviar código"
	},
	"modalCodeConfirmation": {
		"codePlaceholder": "Insira o código enviado",
		"confirmSign": "Confirmar assinatura",
		"description": "Insira o código de confirmação para concluir a assinatura da solicitação.",
		"verifyCode": "Código de confirmação"
	},
	"request": "Solicitação #{{request}}",
	"selectAllContracts": "Selecionar todos os contratos",
	"title": "Termos e contratos pendentes"
}
